<template>
  <div class="dashboard-view">
    <top-bar
      title="Dashboard"
    >
      <br><br>
      <el-select
        @change="changePeriod"
        v-model="selectedPeriod"
        placeholder="Perido">
        <el-option
          v-for="period in periods"
          :key="period.id"
          :label="period.name"
          :value="period.id">
          <span style="float: left">{{ period.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ period.startDate | date }} al {{ period.endDate | date }}</span>
        </el-option>
      </el-select>

    </top-bar>
    <scrollable-container>
      <main>

        <el-row :gutter="gutter">
          <el-col>
            <card-chart
              title="Progreso"
            >
              <line-chart
                :datasets="evaluationDatasets"
                :labels="progressLabels"
              />
            </card-chart>
          </el-col>
        </el-row>
        <el-row :gutter="gutter">
          <el-col :span="8">
            <card-chart
              title="Top Distribuidores"
            >
              <table>
                <tr
                  v-for="dealer of topDealers"
                  :key="dealer.id"
                >
                  <td>{{ dealer.dealer.name }}</td>
                  <td>
                    <star-rating :score="dealer.stars"/>
                  </td>
                </tr>
              </table>
            </card-chart>
          </el-col>
          <el-col :span="8">
            <card-chart
              title="Top Sucursales"
            >
              <table>
                <tr
                  v-for="branch of topBranches"
                  :key="branch.id"
                >
                  <td>{{ branch.branch.municipality }}, {{ branch.branch.state }}</td>
                  <td>
                    <star-rating :score="branch.stars"/>
                  </td>
                </tr>
              </table>
            </card-chart>
          </el-col>
          <el-col :span="8">
            <card-chart
              title="Total de Evaluaciones"
            >
              <span class="evaluation-totals">{{ totalEvaluations }}</span>
              <span class="evaluation-label">Evaluaciones</span>
            </card-chart>
          </el-col>
        </el-row>
      </main>
    </scrollable-container>
  </div>
</template>

<script>
import CardChart from '@/components/_shared/charts/card-chart'
import LineChart from '@/components/_shared/charts/line-chart'
import ScrollableContainer from '@/components/scrollable-container'
import TopBar from '@/components/top-bar'
import StarRating from '@/components/star-rating'

/**
 * 'Dashboard.view' Component
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  name: 'DashboardView',
  components: { StarRating, TopBar, ScrollableContainer, LineChart, CardChart },
  data () {
    return {
      gutter: 20,
      selectedPeriod: null
    }
  },
  computed: {
    currentPeriod () {
      return this.$store.getters['charts/currentPeriod']
    },
    totalEvaluations () {
      return this.$store.getters['charts/totalEvaluations']
    },
    topBranches () {
      return this.$store.getters['branchScores/items']
    },
    topDealers () {
      return this.$store.getters['dealerScores/items']
    },
    periods () {
      return this.$store.getters['periods/items']
    },
    progressLabels () {
      return this.$store.getters['charts/labels']
    },
    evaluationDatasets () {
      return this.$store.getters['charts/datasets']
    }
  },
  mounted () {
    // this.$store.dispatch('charts/evaluations')
    this.$store.dispatch('periods/query', { limit: 1000 })
    this.$store.dispatch('charts/currentPeriod').then(() => {
      this.selectedPeriod = this.$store.getters['charts/currentPeriod'].id
    })
  },
  methods: {
    updateChartsData () {
      this.$store.dispatch('dealerScores/query', {
        periodId: this.selectedPeriod,
        sort: 'stars desc',
        with: 'dealer',
        limit: 5
      })
      this.$store.dispatch('branchScores/query', {
        periodId: this.selectedPeriod,
        sort: 'stars desc',
        with: 'branch',
        limit: 5
      })
      this.$store.dispatch('charts/evaluations')
    },
    changePeriod () {
      this.$store
        .dispatch('charts/setCurrentPeriod', { id: this.selectedPeriod })
        .then(() => {
          this.updateChartsData()
        })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
.dashboard-view {
  main {
    padding: 20px;
  }
  table {
    width: 100%;
    tr {
      td {
        padding: 10px 5px;
      }
    }
  }
  .evaluation-totals {
    width: 100%;
    display: block;
    text-align: center;
    @include font-primary(60px, light) color: $--color-primary;
  }
  .evaluation-label {
    width: 100%;
    display: block;
    text-align: center;
    @include font-primary(20px, regular);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/dashboard/dashboard.view.vue